import { ColorPicker } from "../../../../ColorPicker";
import { Colors } from "@zapier/design-system";

type Props = {
  id: string;
  color: string;
  onClose: () => void;
};

const BLUE = "#3298C7";
const PINK = "#D367BD";

const GROUP_NODE_COLOR_PICKER_OPTIONS = [
  { label: "Light gray", color: Colors.GrayWarm5 },
  { label: "Dark Gray", color: Colors.GrayWarm9 },
  { label: "Green", color: Colors.StatusSuccess },
  { label: "Blue", color: BLUE },
  { label: "Pink", color: PINK },
  { label: "Coral", color: Colors.StatusError },
  { label: "Yellow", color: Colors.StatusWarning },
  { label: "White", color: Colors.PrimeWhite },
];

export function GroupNodeColorPicker({ id, color, onClose }: Props) {
  return (
    <ColorPicker
      id={id}
      colorOptions={GROUP_NODE_COLOR_PICKER_OPTIONS}
      color={color}
      isSelfContained={true}
      showHexInput={true}
      onClose={onClose}
    />
  );
}
